import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { SuccessColors } from '@picsart/design-system/foundation/successColors';
import { ErrorColors } from '@picsart/design-system/foundation/errorColors';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';

const useStyles = createUseStyles(
  {
    toast: {
      position: 'fixed',
      bottom: Spacings.s24,
      left: '50%',
      transform: 'translateX(-50%)',
      color: '#ffffff',
      padding: [Spacings.s12, Spacings.s16],
      borderRadius: CornerRadius.r8,
      fontSize: FontSizes.s14,
      fontWeight: FontWeights.medium,
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      zIndex: StackingContext.ToastLayer,
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s12,
      animation: '$slideUp 0.3s ease-out',
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s8,
    },
    success: {
      backgroundColor: SuccessColors.base.action,
    },
    error: {
      backgroundColor: ErrorColors.base.default,
    },
    info: {
      backgroundColor: '#2196F3',
    },
    actionButton: {
      background: 'rgba(255, 255, 255, 0.2)',
      border: 'none',
      borderRadius: CornerRadius.r4,
      color: '#ffffff',
      padding: [Spacings.s4, Spacings.s12],
      fontSize: FontSizes.s14,
      fontWeight: FontWeights.semibold,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      transition: 'background 0.2s ease',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.3)',
      },
      '&:active': {
        background: 'rgba(255, 255, 255, 0.4)',
      },
    },
    '@keyframes slideUp': {
      from: {
        opacity: 0,
        transform: 'translateX(-50%) translateY(20px)',
      },
      to: {
        opacity: 1,
        transform: 'translateX(-50%) translateY(0)',
      },
    },
  },
  { name: 'toast' }
);

export default useStyles;
